// extracted by mini-css-extract-plugin
export default {"padding":"myrequests_padding__lSF73","title":"myrequests_title__r99oC","grey":"myrequests_grey__Y6Dxl","cardpad":"myrequests_cardpad__dAn3r","extrapad":"myrequests_extrapad__+o-bG"};